<template>
  <div class="details">
    <div class="banner">
      <img class="img-100" src="@/assets/img/guoji/banner.png" alt srcset />
    </div>

    <div class="container">
      <div class="row">
        <div class="con">
          <div class="title">{{details.name}}</div>
          <!-- <div class="introduce">介绍</div> -->
          <div class="video" v-if="details.video">
            <video id="video1" :src="details.video" preload="auto" controls="true" controlslist="nodownload" width="100%">
            </video>
          </div>
          <div class="img-list">
            <img
              class="img-100 img"
              v-for="(item,index) in details.subImgList"
              :src="item"
              :key="index"
              alt
              srcset
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      details: JSON.parse(this.$route.query.data)
    };
  }
};
</script>

<style lang='scss'>
.con {
  width: 100%;
  text-align: center;

  .title {
    font-size: 24px;
    padding: 30px;
    font-weight: bold;
  }
  .introduce {
    font-size: 16px;
    text-align: left;
  }
  .img-list {
    padding-bottom: 60px;

    .img {
      margin-bottom: 20px;
    }
  }
}

@media (max-width: 576px) {
  .con {
    .img-list {
      padding: 10px 20px;
    }
  }
}
</style>